import React from "react";
import { Redirect } from "react-router";

export default function UnauthorizedPage() {
  return <Redirect to="/error/error-v3" />;
}
